import { BasemapStyle } from "basemap_manager/BasemapManager";

export const initTheme = BasemapStyle.Light;
